import { useEffect, useState } from 'react';
import { LessonType } from '../interfaces/lesson.interface';

interface UseFetchLessonsParams {
  dayNumber: string;
  lessonNumber: string;
  subjectName: string;
  classNumber: number;
}

export const useFetchLessons = ({
  dayNumber,
  lessonNumber,
  subjectName,
  classNumber,
}: UseFetchLessonsParams) => {
  const [currentLesson, setCurrentLesson] = useState<LessonType | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchLesson = async (): Promise<void> => {
      setIsLoading(true);
      setError(null);

      try {
        const encodedSubject = encodeURIComponent(subjectName);
        const result = await fetch(
          `${process.env.REACT_APP_HOST_URL}/lessons?dayNumber=${dayNumber}&lessonNumber=${lessonNumber}&subjectName.name=${encodedSubject}`
        );

        if (!result.ok) {
          throw new Error('Failed to fetch lesson');
        }

        const data = await result.json();
        const filteredLesson = data.filter(
          (d: LessonType) => d.classNumber === classNumber
        )[0];
        setCurrentLesson(filteredLesson || null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setIsLoading(false);
      }
    };

    fetchLesson();
  }, [dayNumber, lessonNumber, subjectName, classNumber]);

  return { currentLesson, isLoading, error };
};
